import React from "react";
import { BigNumber } from "@ethersproject/bignumber";
import { MaxUint256 } from "@ethersproject/constants";
import { Web3Provider } from "@ethersproject/providers";
import { createContext } from "react";
import { useAccount, useDisconnect, useNetwork, useSigner } from "wagmi";
import { useWeb3Modal } from "@web3modal/react";

export function getLibrary(provider) {
  const library = new Web3Provider(provider);
  library.pollingInterval = 12000;
  return library;
}
// add 10%
export function calculateGasMargin(value) {
  return +(
    (value * BigNumber.from(10000).add(BigNumber.from(1000))) /
    BigNumber.from(10000)
  ).toFixed(0);
  // return value;
}

export const gasEstimationPayable = async (account, fn, data, amount) => {
  if (account) {
    const estimateGas = await fn(...data, MaxUint256).catch(() => {
      return fn(...data, { value: amount.toString() });
    });
    return calculateGasMargin(estimateGas);
  }
};
export const gasEstimationForAll = async (account, fn, data) => {
  if (account) {
    const estimateGas = await fn(...data, MaxUint256).catch(() => {
      return fn(...data);
    });
    return calculateGasMargin(estimateGas);
  }
};
export const url =
  process.env.NODE_ENV === "production" ? "" : "http://localhost:3000";
let initialState = {
  provider: null,
  web3Provider: null,
  account: null,
  chainId: null,
  signer: null,
};
export const AppContext = createContext(initialState);
export const AppContextProvider = ({ children }) => {
  const { address, isConnected } = useAccount();
  const { open: connect } = useWeb3Modal();
  const { disconnect } = useDisconnect();
  const { data: signer } = useSigner();
  const { chains } = useNetwork();
  const chainId = chains?.map((info) => info?.id);

  return (
    <AppContext.Provider
      value={{
        account: address ?? null,
        signer: signer ?? null,
        connect,
        disconnect,
        gasEstimationForAll,
        isConnected,
        chainId: chainId[0] ?? null,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
